module.exports = __webpack_public_path__ + "img/trylearn.31d95a02.png";